import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguageContext } from '../../context/language_context';
import { BreadcrumbJsonLd } from '../SEOHead/JsonLd';

/**
 * SEO Breadcrumb Navigation
 *
 * Usage:
 *   <Breadcrumb items={[
 *     { name: 'Home', url: '/' },
 *     { name: 'Products', url: '/products' },
 *     { name: 'Product Name' }  // last item has no url
 *   ]} />
 */
const Breadcrumb = ({ items }) => {
  const { isArabic } = useLanguageContext();

  if (!items || items.length === 0) return null;

  return (
    <>
      <BreadcrumbJsonLd items={items} />
      <BreadcrumbWrapper dir={isArabic ? 'rtl' : 'ltr'}>
        <nav aria-label='breadcrumb'>
          <ol className='breadcrumb-list'>
            {items.map((item, index) => {
              const isLast = index === items.length - 1;
              return (
                <li key={index} className={`breadcrumb-item ${isLast ? 'active' : ''}`}>
                  {isLast || !item.url ? (
                    <span>{item.name}</span>
                  ) : (
                    <>
                      <Link to={item.url}>{item.name}</Link>
                      <span className='separator'>{isArabic ? '\\' : '/'}</span>
                    </>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </BreadcrumbWrapper>
    </>
  );
};

const BreadcrumbWrapper = styled.div`
  padding: 0.75rem 1.5rem;
  margin-bottom: 0.5rem;

  .breadcrumb-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 0.85rem;
  }

  .breadcrumb-item {
    display: flex;
    align-items: center;

    a {
      color: #666;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: #222;
        text-decoration: underline;
      }
    }

    .separator {
      margin: 0 0.5rem;
      color: #999;
    }

    &.active span {
      color: #222;
      font-weight: 500;
    }
  }
`;

export default Breadcrumb;
